// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d7bfdcd1","453":"20359781","947":"de7ee6a5","972":"5006c30e"}[chunkId] + ".chunk.js";
};